import { schema } from 'normalizr';
import { SCHEMA_TYPE_VENDOR_AUTH_TEMPLATES } from '../constants/schemaTypes';
import vendorAuthParamSchema from './vendorAuthParam';

const vendorAuthTemplateSchema = new schema.Entity(SCHEMA_TYPE_VENDOR_AUTH_TEMPLATES, {
  auth_parameters: [vendorAuthParamSchema],
});

export default vendorAuthTemplateSchema;
